import { graphql } from "react-relay";
import "../chrome-wrapper";

export const chromeWrapperRendererQuery = graphql`
  query ChromeWrapperRendererQuery {
    viewer {
      ...ChromeWrapper_viewer
    }
  }
`;
